import React, { useState, useEffect } from "react";

const CommonButton = ({ title, onClick, className = "", ...props }) => {
  const [ripples, setRipples] = useState([]);
  useEffect(() => {
    if (ripples.length > 0) {
      const timer = setTimeout(() => {
        setRipples([]);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [ripples]);

  const createRipple = (event) => {
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    const x = event.clientX - rect.left - size / 2;
    const y = event.clientY - rect.top - size / 2;

    const newRipple = {
      x,
      y,
      size,
      id: Date.now(),
    };

    setRipples((prev) => [...prev, newRipple]);
    if (onClick) onClick(event);
  };

  return (
    <button
      {...props}
      onClick={createRipple}
      className={`
        relative overflow-hidden transition-all duration-300 active:scale-95
        bg-[#666CFF] hover:bg-[#5a60e0] cursor-pointer text-white 
        px-[20px] md:px-[27px] py-[7px] md:py-[10px] 
        rounded-[8px] font-[500] text-[13px] md:text-[14px] 
        shadow-[0px_4px_8px_-4px_#4C4E646B] hover:shadow-[0px_6px_12px_-4px_#4C4E648A]
        ${className}
      `}
    >

      {ripples.map((ripple) => (
        <span
          key={ripple.id}
          className="absolute bg-white/30 rounded-full animate-ripple pointer-events-none"
          style={{
            top: ripple.y,
            left: ripple.x,
            width: ripple.size,
            height: ripple.size,
          }}
        />
      ))}


      <span className="relative z-10">{title}</span>
    </button>
  );
};

export default CommonButton;